import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSkeletonSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 228 36" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#C2C5CC">
      <path d="M7 21v15M24.75 7.5l202.75-.25M24.75 22.625l126.75-.375" />
      <circle cx={7} cy={7} r={6.5} />
    </g>
  </svg>
);
const Memo = memo(SvgSkeletonSmall);
export default Memo;
